import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { CollapseModule } from 'ngx-bootstrap/collapse';
import { DragToSelectModule } from 'ngx-drag-to-select';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { CheckUrlAccessGuard } from '../guards/check-url-access.guard';
import { ComparatorService } from '../services/datatable/comparator.service';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { ConfirmWindowComponent } from './components/confirm-window/confirm-window.component';
import { FiltreComponent } from './components/filtre/filtre.component';
import { FiltreGestionComponent } from './components/filtre/filtre-gestion/filtre-gestion.component';
import { GuardService } from '../guards/guard.service';
import { HabilitationCLGuard } from '../guards/habilitation-cl.guard';
import { InfobulleComponent } from './components/infobulle/infobulle.component';
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderService } from '../services/loader/loader.service';
import { MessageComponent } from './components/message/message.component';
import { ModalSelectMoreComponent } from './components/filtre/modal-select-more/modal-select-more.component';
import { NavegateurFormulaireComponent } from './components/navegateur-formulaire/navegateur-formulaire.component';
import { PageNumberComponent } from './components/pagination/page-number/page-number.component';
import { PageOrganizationComponent } from './components/pagination/page-organization/page-organization.component';
import { PaginationService } from '../services/pagination/pagination.service';
import { PipesModule } from './pipes/pipes.module';
import { PopUpContactComponent } from './components/pop-up-contact/pop-up-contact.component';
import { QuickCheckboxSelectionComponent } from './components/quick-checkbox-selection/quick-checkbox-selection.component';

@NgModule({
  imports: [
    CollapseModule.forRoot(),
    CommonModule,
    DragToSelectModule.forRoot(),
    FormsModule,
    HttpClientModule,
    ModalModule.forRoot(),
    NgbModule,
    PipesModule,
    ReactiveFormsModule,
    TranslateModule.forChild({ extend: true }),
  ],
  exports: [
    ConfirmationModalComponent,
    ConfirmWindowComponent,
    DragToSelectModule,
    FiltreComponent,
    FiltreGestionComponent,
    FormsModule,
    InfobulleComponent,
    LoaderComponent,
    MessageComponent,
    ModalModule,
    NavegateurFormulaireComponent,
    NgbModule,
    PageNumberComponent,
    PageOrganizationComponent,
    PipesModule,
    PopUpContactComponent,
    QuickCheckboxSelectionComponent,
    ReactiveFormsModule,
    TranslateModule,
  ],
  declarations: [
    ConfirmationModalComponent,
    ConfirmWindowComponent,
    FiltreComponent,
    FiltreGestionComponent,
    InfobulleComponent,
    LoaderComponent,
    MessageComponent,
    ModalSelectMoreComponent,
    NavegateurFormulaireComponent,
    PageNumberComponent,
    PageOrganizationComponent,
    PopUpContactComponent,
    QuickCheckboxSelectionComponent,
  ],
  providers: [
    CheckUrlAccessGuard,
    ComparatorService,
    GuardService,
    HabilitationCLGuard,
    LoaderService,
    PaginationService,
  ]
})
export class SharedModule { }
